// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import Address from '../../../../../../common/molecules/Address';
import BodyCopy from '../../../../../../common/atoms/BodyCopy';
import {
  getDynamicLabelValues,
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '../../../../../../../utils/labels/labelUtilty';
import AccountCommonLabels, { ACCOUNT_LABELS } from '../../../labels/AccountCommon.labels';
import {
  GLOBAL_GENERIC_LABELS,
  GlobalGenericLabels,
  lblCreditCard,
} from '../../../../../../../utils/labels/globalGeneric.labels';

const getDataLocatorPrefix = ({ card }) => {
  switch (card.ccType) {
    case 'GiftCard':
      return 'giftcard';
    case 'VENMO':
      return 'venmo';
    case 'ApplePay':
      return 'applepay';
    default:
      return 'creditdebit';
  }
};

const getCardName = ({ card }) => {
  const accountLabels = getLabelFromCopyOrFromTranslation(ACCOUNT_LABELS, AccountCommonLabels);

  const plccLabel = getDynamicLabelValues('dynamic.account_d.lbl_payment_plccCard');
  switch (card.ccType) {
    case 'GiftCard':
      return renderLabel(accountLabels?.paymentGC?.lbl_payment_giftCard, 'lbl_payment_giftCard');
    case 'PLACE CARD':
      return plccLabel;
    case 'Placecard':
      return plccLabel;
    case 'VENMO':
      return renderLabel(
        accountLabels?.paymentGC?.lbl_payment_venmoAccount,
        'lbl_payment_venmoAccount'
      );
    case 'ApplePay':
      return renderLabel(
        accountLabels?.paymentGC?.lbl_payment_applepayAccount,
        'lbl_payment_applepayAccount'
      );
    default:
      return getLabelFromCopyOrFromTranslation(
        `${GLOBAL_GENERIC_LABELS}.${lblCreditCard}`,
        GlobalGenericLabels
      );
  }
};
const placeCard = 'place-card-small';
const placeCardPJP = 'place-card-pjp-small';
const discoverCard = 'disc-small';

const cardIconMapping = {
  DISC: discoverCard,
  DISCOVER: discoverCard,
  Discover: discoverCard,
  MC: 'mc-small',
  'Master Card': 'mc-small',
  'MASTER CARD': 'mc-small',
  Amex: 'amex-small',
  Visa: 'visa-small',
  GC: 'gift-card-small',
  GIFTCARD: 'gift-card-small',
  'PLACE CARD': placeCard,
  'PLACE CARD_PJP': placeCardPJP,
  PLACECARD: placeCard,
  PLACECARD_PJP: placeCardPJP,
  'MY PLACE REWARDS CREDIT CARD': placeCard,
  'MY PLACE REWARDS CREDIT CARD_PJP': placeCardPJP,
  VENMO: 'venmo-blue-acceptance-mark',
  VISA: 'visa-small',
  AMEX: 'amex-small',
  paypal: 'paypal-icon',
  'APPLE PAY': 'apple-pay-icon',
  applepay: 'applepay-small',
  afterpay: 'after-pay-icon',
  AFTERPAY: 'after-pay-icon',
  visaSPC: 'visa-small-spc',
  discSPC: 'discover-small-spc',
  discoverSPC: 'discover-small-spc',
  amexSPC: 'amex-small-spc',
  mcSPC: 'mastercard-small-spc',
  mastercardSPC: 'mastercard-small-spc',
  paypalSPC: 'paypal-small-spc',
  placecardSPC: 'elements-plcc-card',
  'place cardSPC': 'elements-plcc-card',
  Placecard: placeCard,
  placecardPJP: placeCardPJP,
  'place cardPJPSPC': 'elements-plcc-card-pjp',
  placecardPJPSPC: 'elements-plcc-card-pjp',
  Placecard_PJP: placeCardPJP,
};

const cardTypeMapping = {
  mc: 'mastercard',
  'master card': 'mastercard',
  visa: 'visa',
  amex: 'amex',
  disc: 'discover',
  discover: 'discover',
  placecard: 'placecard',
  'place card': 'placecard',
};

const getAddressDetails = ({ card }) => {
  return (
    card.addressDetails && (
      <Address
        address={card.addressDetails}
        fontWeight="normal"
        showCountry={false}
        showPhone={false}
        dataLocatorPrefix="payment-creditcard"
      />
    )
  );
};

const loading = (isGiftCardBalanceRequested, balance) => {
  const accountLabels = getLabelFromCopyOrFromTranslation(ACCOUNT_LABELS, AccountCommonLabels);

  return (
    <React.Fragment>
      {isGiftCardBalanceRequested && !balance && (
        <BodyCopy
          tag="span"
          fontSize="fs24"
          fontFamily="secondary"
          fontWeight="extrabold"
          className=""
          lineHeights="lh115"
        >
          {renderLabel(
            accountLabels?.common?.lbl_giftCardBalanceLoading,
            'lbl_giftCardBalanceLoading'
          )}
        </BodyCopy>
      )}
    </React.Fragment>
  );
};

export {
  getDataLocatorPrefix,
  getCardName,
  cardIconMapping,
  cardTypeMapping,
  getAddressDetails,
  loading,
};
